import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 120px;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 24px;
  margin-bottom: 30px;
`;

const HomeLink = styled(Link)`
  padding: 10px 20px;
  border: 1px solid #000;
  text-decoration: none;
  color: #000;
  &:hover {
    background-color: #000;
    color: #fff;
  }
`;

const NotFoundPresenter = () => {
  return (
    <Wrapper>
      <Title>404</Title>
      <Message>페이지를 찾을 수 없습니다.</Message>
      <HomeLink to="/">메인으로 돌아가기</HomeLink>
    </Wrapper>
  );
};

export default NotFoundPresenter;